export default "__VITE_ASSET__CATJjrGp__"